import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchAssocitedPartiesData, fetchPartyInfo ,addAssociateParty, deleteAssociateParty,
    changePartiesLog,setPartyAssociation, updateAssociatedPartiesData, resetAssociatedParties, updateContactRelationshipType} from '../actions/action';
import { showDialogueBox, hideDialogueBox } from '../../../components/DialogueBox/actions';
import CreateParty from './createParty';
import PartyInfo from "./partyInfo";
import {fetchMiddlePanelPartiesData, resetMiddlePanel } from '../../../containers/WorkkardDetail/actions/action';
import Icon from '../../../icons';
import LoaderComponent from '../../../components/Loader';
import ConfirmationTextBox from "../../../components/ConfirmationPrompt";
import ListingComponent from "../../../components/ListingComponent";
import PartiesListingCell from "./partiesListingCell";
import {quickScroll} from "./constants";
import { isOnDetailPage } from '../Notification/utils'
import ContactRelationShipTypes from "./ContactRelationShipTypes";
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';

const AssociatedParties = (props) => {
    const dispatch = useDispatch();
    const associatedPartiesData = useSelector(state => state.header.associatedParties);
    const activeTab = useSelector(state => state.header.associatedParties.associatedPartiesData.activeTab);
    const isLoading = useSelector(state => state.header.associatedParties.isLoading);
    const associateWith = useSelector(state => state.header.associatedParties.associateWith);
    const workkardId = useSelector(state => state.workkardDetail.workkardDetail.Id);
    const activityId = useSelector(state => state.workkardDetail.activityDetail.activityId);
    const parties = useSelector(state => state.workkardDetail.middlePanel.parties);
    const orgId = useSelector(state => state.workkardDetail.workkardDetail.OrganizationId);
    const claimSource = useSelector(state => state.workkardDetail.workkardDetail.CustomFields);
    const carrierId = useSelector(state => state.workkardDetail.workkardDetail.CarrierId);
    const sessionContext = useSelector(selectSessionContextOidc);
    const userView = sessionContext?.userView;
    const currentUserOrgId = userView?.orgId;

    const partiesPayloadRef = React.useRef({
        privacy: 'all',
        searchstring: '',
        startwith: '',
        id: 0,
        skip: 1,
        take: 15,
        type: null,
        activeTab: 0,
        carrier_id: 0,
        _: + new Date()
    });

    const [isCreate, setIsCreate] = React.useState(false);
    const [editId, setEditId] = React.useState(null);
    const [showPartyInfo, setShowPartyInfo] = React.useState(false);
    const [searchString, setSearchString] = React.useState("");
    const [tabValue, setTabValue] = React.useState("");
    const [hidepersonalParty, setHidepersonalParty] = React.useState(false);
    const [isScrollDisable, setIsScrollDisable] = React.useState(false);
    const [currentAssociatingParty, setCurrentAssociatingParty] = React.useState(null);

    const stateRef = React.useRef({});
    stateRef.current = { hidepersonalParty, isScrollDisable, currentAssociatingParty };

    // componentDidMount
    React.useEffect(() => {
        const orgs = process.env.restrict_personal_party_for_orgs.split(",").map(element => element.trim());
        const fields = process.env.restrict_personal_party_for_field.split(",").map(element => element.trim());
        const datasource = process.env.restrict_personal_party_for_claim_source.split(",").map(element => element.trim().toUpperCase());
        let pphide = false;
        if (claimSource != undefined) {
            claimSource.forEach(element => {
                if (fields.indexOf(element.FieldGroup) != -1 && datasource?.indexOf(element.Value.replace(/\s/g, '').toUpperCase()) != -1 && orgs?.indexOf(orgId.toString()) != -1) {
                    pphide = !(associateWith === "activity");
                }
            });
            setHidepersonalParty(pphide);
        }
        if (props.showPartyInfo) {
            setShowPartyInfo(true);
        } else if (props.createAssociatedParties && props.createAssociatedParties == 'createAssociatedParties') {
            onCreateClick();
        } else {
            const isRestrictedOrg = false;//orgs?.indexOf(orgId.toString()) != -1 ? true : false;
            let payload = Object.assign({}, partiesPayloadRef.current);
            payload.privacy = pphide ? "organization" : payload.privacy;
            payload.activeTab = pphide ? 2 : payload.activeTab;
            payload.id = associateWith ? (associateWith === "activity" ? activityId : workkardId) : (isOnDetailPage() ? (activityId || workkardId) : 0);
            payload.type = associateWith || (isOnDetailPage() ? (activityId ? 'activity' : 'workkard') : null);
            payload.carrier_id = carrierId ? carrierId : 0;
            let partySource = null;
            if (claimSource != undefined) {
                claimSource.forEach(element => {
                    if (element.FieldGroup == "Claim Source") {
                        partySource = element.Value;
                    }
                });
            }
            payload.pr_source = partySource;
            dispatch(fetchAssocitedPartiesData(payload));
        }
    }, []);

    // componentWillUnmount
    React.useEffect(() => {
        return () => {
            dispatch(setPartyAssociation(null));
        };
    }, []);

    // componentDidUpdate: sync associateWith → partiesPayload
    const prevAssociateWithRef = React.useRef(associateWith);
    React.useEffect(() => {
        if (prevAssociateWithRef.current !== associateWith) {
            partiesPayloadRef.current.id = associateWith ? (associateWith === "activity" ? activityId : workkardId) : (isOnDetailPage() ? (activityId || workkardId) : 0);
            partiesPayloadRef.current.type = associateWith || (isOnDetailPage() ? (activityId ? 'activity' : 'workkard') : null);
        }
        prevAssociateWithRef.current = associateWith;
    }, [associateWith]);

    // componentDidUpdate: sync activeTab → partiesPayload
    const prevActiveTabRef = React.useRef(activeTab);
    React.useEffect(() => {
        if (prevActiveTabRef.current !== activeTab) {
            partiesPayloadRef.current.activeTab = activeTab;
        }
        prevActiveTabRef.current = activeTab;
    }, [activeTab]);

    // componentDidUpdate: sync searchString → partiesPayload
    React.useEffect(() => {
        partiesPayloadRef.current.searchstring = searchString;
    }, [searchString]);

    // componentDidUpdate: sync tabValue → partiesPayload
    React.useEffect(() => {
        partiesPayloadRef.current.privacy = tabValue;
    }, [tabValue]);

    // componentDidUpdate: trigger onCreateClick when createAssociatedParties changes from undefined
    const prevCreateAssociatedPartiesRef = React.useRef(props.createAssociatedParties);
    React.useEffect(() => {
        if (prevCreateAssociatedPartiesRef.current == undefined && props.createAssociatedParties && props.createAssociatedParties == 'createAssociatedParties') {
            onCreateClick();
        }
        prevCreateAssociatedPartiesRef.current = props.createAssociatedParties;
    }, [props.createAssociatedParties]);

    const getPartySource = () => {
        let partySource = null;
        if (claimSource != undefined) {
            claimSource.forEach(element => {
                if (element.FieldGroup == "Claim Source") {
                    partySource = element.Value;
                }
            });
        }
        return partySource;
    };

    const getEntityId = () => associateWith ? (associateWith === "activity" ? activityId : workkardId) : (isOnDetailPage() ? (activityId || workkardId) : 0);
    const getEntityType = () => associateWith || (isOnDetailPage() ? (activityId ? 'activity' : 'workkard') : null);

    const onCreateClick = () => {
        setIsCreate(true);
        setEditId(null);
    };

    const onClose = () => {
        dispatch(resetAssociatedParties());
        props.onClose();
    };

    const closeForm = () => {
        setIsCreate(false);
        setEditId(null);
        if (props.openedFromMiddleTab) {
            props.onClose();
            dispatch(resetMiddlePanel({ type: 'parties', value: parties.type }));
            const payload = {
                cId: workkardId,
                type: parties.type,
                actId: activityId || 0,
                skip: 0,
                take: 15,
                sortBy: 1,
                filterOption: parties.filter.filterOption,
                sort: "OPEN",
                rows: 15,
            };
            dispatch(fetchMiddlePanelPartiesData(payload));
        }
        if (props.createAssociatedParties == 'createAssociatedParties') {
            onClose();
        }
    };

    const onTabClick = (tabNumber, tv) => {
        setSearchString("");
        setTabValue(tv);
        setEditId(null);
        setIsCreate(false);
        let payload = Object.assign({}, partiesPayloadRef.current);
        payload.privacy = tv;
        payload.searchstring = "";
        payload.activeTab = tabNumber;
        payload.id = getEntityId();
        payload.type = getEntityType();
        payload.carrier_id = carrierId ? carrierId : 0;
        payload.pr_source = getPartySource();
        dispatch(fetchAssocitedPartiesData(payload));
    };

    const onInfoClick = (id) => {
        const payload = {
            id: id,
            flag: 'detail',
            entity: '',
            entity_id: getEntityId(),
            entity_type: getEntityType(),       //activity/workkard
        };
        setShowPartyInfo(true);
        dispatch(fetchPartyInfo(payload));
    };

    const onScrollHandler = () => {
        const { hidepersonalParty } = stateRef.current;
        if (!associatedPartiesData.associatedPartiesData.Data.stopScroll) {
            const { skip, take } = associatedPartiesData.associatedPartiesData;
            let payload = Object.assign({}, partiesPayloadRef.current);
            payload.privacy = hidepersonalParty ? "organization" : payload.privacy;
            payload.activeTab = hidepersonalParty ? 2 : payload.activeTab;
            payload.skip = skip + 1;
            payload.take = take;
            payload.id = getEntityId();
            payload.type = getEntityType();
            payload.carrier_id = carrierId ? carrierId : 0;
            payload.pr_source = getPartySource();
            dispatch(updateAssociatedPartiesData(payload));
        }
    };

    const associateParty = (partyDetails) => {
        const { party_id, contact_relationship_type_id, partyType } = partyDetails;
        let partyTypes = process.env.party_types_for_adding_contactrelship.split(",").map(element => element.trim());
        let showContactRelPopup = partyTypes.includes(partyType?.toLowerCase()) && contact_relationship_type_id == null;
        if (showContactRelPopup) {
            let contactRelationShipTypeList = associatedPartiesData.associatedPartiesData.Data.contactRelationTypelist;
            dispatch(showDialogueBox({
                flag: true,
                component: <ContactRelationShipTypes
                    contactRelationShipTypeList={contactRelationShipTypeList}
                    onCancelClick={() => dispatch(hideDialogueBox())}
                    onConfirmClick={(contatRelTypeId) => selectedContactRelationType(party_id, contatRelTypeId)}
                />,
                overlayClassName: "modal",
                contentClassName: "modalContent small animated fullView faster fadeInUpx2 confirmModal",
                shouldCloseOnOverlayClick: true
            }));
        } else {
            const prevAssociatingParty = stateRef.current.currentAssociatingParty;
            setCurrentAssociatingParty(party_id);
            const payload = {
                eid: getEntityId(),
                pid: party_id,
                type: associateWith ? (associateWith === "activity" ? 'act' : 'wrk') : (isOnDetailPage() ? (activityId ? 'activity' : 'workkard') : ""),
                successCallback: onClose
            };
            if (prevAssociatingParty != party_id) {
                dispatch(addAssociateParty(payload));
            }
        }
    };

    const selectedContactRelationType = (partyId, contatRelTypeId) => {
        const payload = {
            partyId: partyId,
            contactRelationId: contatRelTypeId,
            callback: (status) => onSuccessUpdateContactRelationType(partyId, status)
        };
        dispatch(updateContactRelationshipType(payload));
    };

    const onSuccessUpdateContactRelationType = (partyId, status = false) => {
        if (!status) return;
        dispatch(hideDialogueBox());
        const payload = {
            eid: getEntityId(),
            pid: partyId,
            type: associateWith ? (associateWith === "activity" ? 'act' : 'wrk') : (isOnDetailPage() ? (activityId ? 'activity' : 'workkard') : ""),
            successCallback: onClose
        };
        dispatch(addAssociateParty(payload));
    };

    const onEditClick = (id) => {
        setEditId(id);
        setIsCreate(true);
    };

    const onDeleteClick = (id) => {
        const payload = { id: id };
        dispatch(showDialogueBox({
            flag: true,
            component: <ConfirmationTextBox
                class={"modalBody"}
                message={"Are you sure you want to delete this Party?"}
                onConfirmClick={() => dispatch(deleteAssociateParty(payload))}
                onCancelClick={() => dispatch(hideDialogueBox())}
                confirmationText={"Delete Party"}
                footerClass={"modalFooter"}
                cancelText={"Cancel"}
            />,
            overlayClassName: "modal",
            contentClassName: "modalContent small animated faster fadeInUpx2",
            shouldCloseOnOverlayClick: true
        }));
    };

    const searchParties = (value) => {
        let trimmedValue = value.trim("");
        setSearchString(value);
        let payload = Object.assign({}, partiesPayloadRef.current);
        payload.privacy = stateRef.current.hidepersonalParty ? "organization" : payload.privacy;
        payload.activeTab = stateRef.current.hidepersonalParty ? 2 : payload.activeTab;
        payload.id = getEntityId();
        payload.type = getEntityType();
        payload.searchstring = trimmedValue;
        payload.carrier_id = carrierId ? carrierId : 0;
        payload.pr_source = getPartySource();
        dispatch(fetchAssocitedPartiesData(payload));
    };

    const handleQuickScroll = (data) => {
        let payload = Object.assign({}, partiesPayloadRef.current);
        if (data == '#') {
            payload.startwith = "";
            setIsScrollDisable(false);
        } else {
            payload.startwith = data;
            setIsScrollDisable(true);
        }
        payload.privacy = stateRef.current.hidepersonalParty ? "organization" : payload.privacy;
        payload.activeTab = stateRef.current.hidepersonalParty ? 2 : payload.activeTab;
        payload.id = getEntityId();
        payload.type = getEntityType();
        payload.carrier_id = carrierId ? carrierId : 0;
        payload.pr_source = getPartySource();
        dispatch(fetchAssocitedPartiesData(payload));
    };

    const editPartyFromInfo = (id) => {
        setShowPartyInfo(false);
        setEditId(id);
        setIsCreate(true);
    };

    const renderListing = (data) => {
        const { hidepersonalParty, isScrollDisable } = stateRef.current;
        const prop = {
            data: data,
            cellTemplate: PartiesListingCell,
            onScrollHandler: !isScrollDisable && onScrollHandler,
            onItemClick: (party_id) => onInfoClick(party_id),
            onCellClick: (partyDetails) => associateParty(partyDetails),
            type: "ul",
            selectedId: '',
            classname: 'scrollArea partyScroll',
            extraData: { editClick: ((id) => onEditClick(id)), deleteClick: ((id) => onDeleteClick(id)), hidepersonalParty }
        };
        return (<ListingComponent {...prop} />);
    };

    const { showDelete, handleDelete } = props;
    const isRestrictedOrg = false;//orgs?.indexOf(orgId.toString()) != -1 ? true : false;
    const isRestrictedOrgCreate = false;//orgs?.indexOf(currentUserOrgId.toString()) != -1 ? true : false;

    if (showPartyInfo) {
        return (
            <PartyInfo showDelete={showDelete} handleDelete={handleDelete} editPartyFromInfo={editPartyFromInfo} onBackClick={() => { setShowPartyInfo(false); }} onClose={onClose} openedFromMiddleTab={props.openedFromMiddleTab || false} showBackButton={props.openedFromMiddleTab ? false : true} />
        );
    }
    return (
        <>
        {
            (associatedPartiesData && associatedPartiesData.associatedPartiesData.errorMessage) ?
            <div className="newNotificationMsg stickyErrorMessage">
                {associatedPartiesData.associatedPartiesData.errorMessage}
            </div>
            :
            ""
        }
            <div className="associatedParties" style={{ 'paddingTop': (associatedPartiesData && associatedPartiesData.associatedPartiesData.errorMessage) ? "10px" : "0px" }}>
            <header className="alignMiddle pdl__1 pdr__1">
            {editId && !props.openedFromMiddleTab && <a href="javascript:void(0)" className="backArrow mr" onClick={() => { setEditId(null); setIsCreate(false); }}><Icon name="chev" className="icon shift__top__1 arrow" /></a>}
                <div className="flexGrow"><h2 className="alignBase flexWrap">{!editId ? 'Associated Parties' : 'Edit Party'}</h2>
                {!isCreate && !isRestrictedOrgCreate && !hidepersonalParty && <button className="btn buttonGradient addIcon btnAdd" onClick={onCreateClick}><Icon name="add" className="icon" /></button>}
                </div>
                <a className="h__16 ml__1" href="javascript:void(0)" onClick={onClose}><Icon name="close" className="icon" /></a>
            </header>
            {!isCreate &&
                <>
                    <div className="tabNav mb pdl__1">
                        <div className="tabs">
                            {!isRestrictedOrg && !hidepersonalParty && <a href="javascript:void(0)" className={activeTab === 0 ? "active" : ''} onClick={() => onTabClick(0, 'all')}><span>All </span></a>}
                            {!isRestrictedOrgCreate && !hidepersonalParty && <a href="javascript:void(0)" className={activeTab === 1 ? "active" : ''} onClick={() => onTabClick(1, 'personal')}><span>Personal</span></a>}
                            <a href="javascript:void(0)" className={activeTab === 2 ? "active" : ''} onClick={() => onTabClick(2, 'organization')}><span>Organization</span></a>
                        </div>
                    </div>
                    <div className="formGroup search pdl__1 pdr__1 mb">
                        <span className="searchIcon"><Icon name="search" className="icon" /></span>
                        <input type="text" id="searchparty_txt" placeholder="Search Associated Parties" onChange={(e) => searchParties(e.target.value)} value={searchString} />
                    </div>
                </>
            }

            {
                isCreate ?
                (
                    <CreateParty closeForm={closeForm}
                            onSuccess={() => onTabClick(1, 'personal')}
                            editId={editId}
                            openedFromMiddleTab={props.openedFromMiddleTab || false}
                        />
                )
                :
                (
                <React.Fragment>
                        <div className="partyListing partyScroll">
                            <div className="partyListingGroup">
                                {
                                    isLoading &&
                                    <LoaderComponent />
                                }
                                {
                                    associatedPartiesData.associatedPartiesData.Data && associatedPartiesData.associatedPartiesData.Data.length > 0 ?
                                        renderListing(associatedPartiesData.associatedPartiesData.Data.partyitem)
                                        :
                                        <div className="noDataFound">
                                            No result found.
                                        </div>
                                }
                            </div>
                            <div className="partyListFilter animated faster fadeInRight">
                                <ul className="colFlex">
                                    {
                                        quickScroll.map((item, key) => {
                                            return (
                                                <li key={key}>
                                                    <a href="javascript:void(0);" onClick={() => handleQuickScroll(item)}>{item}</a>
                                                </li>
                                            );
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </React.Fragment>
                )
            }
                 {/* <footer>
                    <button className="btn" onClick={onCreateClick}>Add</button>
                </footer> */}
        </div>
        </>
    );
};

export default AssociatedParties;

